import styled, { keyframes } from 'styled-components';

const carouselAnimation = (quantity: number, slideWidth: number) => keyframes`
  0% {
    transform: translateX(100vw);
  }
  100% {
    transform: translateX(calc(-${slideWidth}px * ${quantity})) ;
  }
`;

export const AnimatedContainer = styled.div`
  width: 99vw;
  display: grid;
  overflow: hidden;
  position: relative;
`;

export const SliderTrack = styled.div<{ quantity: number }>`
  width: ${({ quantity }) => `calc(104px * ${quantity})`};
  display: flex;
  animation: ${({ quantity }) => carouselAnimation(quantity, 104)} 25s linear
    infinite;
  ${({ theme }) => theme.breakpoints.up('sm')} {
    width: ${({ quantity }) => `calc(104px * ${quantity})`};
    animation: ${({ quantity }) => carouselAnimation(quantity, 132)} 30s linear
      infinite;
  }
`;
